import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getSmartScanCaseReport_Ajax } from "../../helpers/requests";
import { useDispatch, useSelector } from "react-redux";
import {
  hideLoadingSpinner,
  showLoadingSpinner
} from "../../redux/actions/loadingSpinner";
import {
  handleApiErrors,
  openUrlInNewTab,
  showAlertDialouge,
  getSeeADentistNowButtonText
} from "../../helpers/utils";
import DentalConditionDetailsAccordion from "./DentalConditionDetailsAccordion";
import SmartScanGraph from "../SmartScanGraph/SmartScanGraph";
import { SmartScanGraphDataPropertyIndices } from "../../constants";

const WellnessScorePage = (props) => {
  const { smartScanId, patientId } = props;
  const dispatch = useDispatch();
  const [smartScanCaseReport, setSmartScanCaseReport] = useState(null);
  const [smartScanLatestId, setSmartScanLatestId] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const currentPatient = useSelector((state) => state.userData.currentPatient);
  const onDemandCampaignCharge = useSelector((state) => {
    if (state?.userData?.onDemandCampaignCharge > 0) {
      return state?.userData?.onDemandCampaignCharge;
    } else if (location.state?.userData?.onDemandCampaignCharge > 0) {
      return location.state?.userData?.onDemandCampaignCharge;
    }

    return 0;
  });

  useEffect(() => {
    getSmartScanCaseReport(smartScanId);
  }, [smartScanId]);

  useEffect(() => {
    if (currentPatient) {
      setSmartScanCaseReport(null);
      getSmartScanCaseReport(smartScanId);
    }
  }, [currentPatient]);

  function getSmartScanCaseReport(smartScanId) {
    let params = {
      includeDetails: true,
      patId: patientId,
      shouldGetLatestSmartScanCaseReport: smartScanId > 0 ? false : true
    };

    dispatch(showLoadingSpinner());
    getSmartScanCaseReport_Ajax(
      smartScanId,
      params,
      function (resposne) {
        dispatch(hideLoadingSpinner());

        if (
          resposne &&
          resposne?.success &&
          resposne?.data?.smartScanCaseReportVM
        ) {
          setSmartScanCaseReport(resposne.data.smartScanCaseReportVM);
          setSmartScanLatestId(resposne.data.smartScanCaseReportVM.smartScanId);
        }
      },
      function (err) {
        dispatch(hideLoadingSpinner());
        handleApiErrors(err);
      }
    );
  }

  function renderSmartScanChart() {
    return patientId > 0 ? (
      <SmartScanGraph
        patientId={patientId}
        onGraphPointClicked={onGraphPointClicked}
        smartScanId={getSmartScanId()}
      />
    ) : (
      <></>
    );
  }

  function onGraphPointClicked(smartScan) {
    if (
      smartScan &&
      smartScan[SmartScanGraphDataPropertyIndices.SmartScanId] > 0
    ) {
      getSmartScanCaseReport(
        smartScan[SmartScanGraphDataPropertyIndices.SmartScanId]
      );
    }
  }

  function getSmartScanId() {
    return smartScanId > 0 ? smartScanId : smartScanLatestId;
  }

  function onSeeADentistNowButtonClicked() {
    if ((smartScanId > 0 || smartScanLatestId > 0) && patientId > 0) {
      navigate("/see-dentist", {
        state: {
          smartScanId: getSmartScanId(),
          patientId
        }
      });
    }
  }

  function onPrintBtnClicked() {
    if (smartScanCaseReport?.smartScanId > 0) {
      let url =
        "/wellness-score-print/" +
        smartScanCaseReport?.smartScanId +
        "?patid=" +
        patientId;
      openUrlInNewTab(url);
    }
  }

  return (
    <>
      <div className="container">
        <div className="row mb-3">
          <div className="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Wellness Score
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <h1 className="mb-4">Smart Scan</h1>
            {renderSmartScanChart()}
            <div className="collapse show" id="collapseSmartScan">
              <div
                className="accordion wellness-score-accordion wellness-accordion1"
                id="accordionSmartScan"
              >
                {smartScanCaseReport?.smartScanCaseReportId > 0 ? (
                  <>
                    <DentalConditionDetailsAccordion
                      title={"Cavities"}
                      dentalConditionData={smartScanCaseReport?.cavity}
                      onDemandCampaignCharge={onDemandCampaignCharge}
                      onSeeADentistNowButtonClicked={
                        onSeeADentistNowButtonClicked
                      }
                    />

                    <DentalConditionDetailsAccordion
                      title={"Defective Restoration"}
                      dentalConditionData={
                        smartScanCaseReport?.defectiveRestoration
                      }
                      onDemandCampaignCharge={onDemandCampaignCharge}
                      onSeeADentistNowButtonClicked={
                        onSeeADentistNowButtonClicked
                      }
                    />

                    <DentalConditionDetailsAccordion
                      title={"Broken Tooth"}
                      dentalConditionData={smartScanCaseReport?.brokenTooth}
                      onDemandCampaignCharge={onDemandCampaignCharge}
                      onSeeADentistNowButtonClicked={
                        onSeeADentistNowButtonClicked
                      }
                    />

                    <DentalConditionDetailsAccordion
                      title={"Plaque Buildup"}
                      dentalConditionData={smartScanCaseReport?.plaqueBuildUp}
                      onDemandCampaignCharge={onDemandCampaignCharge}
                      onSeeADentistNowButtonClicked={
                        onSeeADentistNowButtonClicked
                      }
                    />

                    <DentalConditionDetailsAccordion
                      title={"Gum Inflammation"}
                      dentalConditionData={smartScanCaseReport?.gumInflammation}
                      onDemandCampaignCharge={onDemandCampaignCharge}
                      onSeeADentistNowButtonClicked={
                        onSeeADentistNowButtonClicked
                      }
                    />

                    <div className="text-center">
                      <button
                        onClick={onSeeADentistNowButtonClicked}
                        className="btn btn-secondary btn-lg text-nowrap px-5 mx-3 mt-2 mt-md-0"
                      >
                        {getSeeADentistNowButtonText()}
                      </button>
                      <button
                        onClick={onPrintBtnClicked}
                        className="btn btn-primary btn-lg text-nowrap px-5 mx-3 mt-2 mt-md-0"
                      >
                        Print or Share
                      </button>
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WellnessScorePage;
